import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const BORutinMeny: IRutinInfo[] = [
  rutinInfos.rtnWebKalender,
  rutinInfos.rtnGudstjansttyp,
  rutinInfos.rtnAktiviteter,
  rutinInfos.rtnFakturaOmgang,
  rutinInfos.rtnResurser,
  rutinInfos.rtnOPGrupp,
  rutinInfos.rtnGruppmedlemmar,
  rutinInfos.rtnSammankomst,
  rutinInfos.rtnBegrByra,
  rutinInfos.rtnWebPlanering,
  rutinInfos.rtnAdresser_HarUtgatt,
  rutinInfos.rtnPostnr,
  rutinInfos.rtnTvist,
  rutinInfos.rtnStatistikrapporteringNew,
  rutinInfos.rtnAnnonseras,
  rutinInfos.rtnBestallningar,
  rutinInfos.rtnWebOrder,
  rutinInfos.rtnTjanstgoring,
  rutinInfos.rtnOrgPersLok,
];

export default BORutinMeny;
